"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var loadScript = function (url) {
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = url;
        script.onload = resolve;
        script.onerror = reject;
        if (document.body) {
            document.body.appendChild(script);
        }
    });
};
exports.default = loadScript;
